/** Parses a WKT point string ("POINT (lng lat)") into { lat, lng }. */
export function parseWKTPoint(wkt?: string): { lat: number; lng: number } | null {
  if (!wkt) return null;
  const match = wkt.match(/POINT\s*\(\s*([-\d.]+)\s+([-\d.]+)\s*\)/);
  if (!match) return null;
  return { lng: parseFloat(match[1]), lat: parseFloat(match[2]) };
}
